
import React from "react";
import { connect } from "react-redux";

import history from "../../auth/history";
import UploadHistoryFileListDetails from "./UploadHistoryFileListDetails";
import './uploadHistory.css';
import Pagination from "react-js-pagination";
class UploadHistorySubComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            activePage:1,
            startIndex:0,
            endIndex:5,
        }
    }





    componentDidMount() { 
        
    }
    componentWillUnmount() {
    }


    handlePageChangeDefault(pageNumber) {
        this.setState({
            activePage: pageNumber
        })

        console.log(pageNumber);
        var startIndex = (pageNumber - 1) * 5;
        var endIndex = pageNumber * 5;

        this.setState({
            startIndex: startIndex,
            endIndex: endIndex,
        })



    }

    render() {

        return (
            <div>
                <div class="filehistory">
                    {this.props.bulkUploadHistory
                    .slice(this.state.startIndex,this.state.endIndex)
                    .map(upload => (
                        <UploadHistoryFileListDetails
                            upload={upload} />
                    ))}


                </div>

                <div class="pager">
                    <p>Showing {this.state.startIndex+1} to {this.state.endIndex >=
                    this.props.bulkUploadHistory.length?
                    this.props.bulkUploadHistory.length:
                    this.state.endIndex} of {this.props.bulkUploadHistory.length} entries</p>
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={5}
                        totalItemsCount={
                            this.props.bulkUploadHistory.length}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChangeDefault.bind(this)}
                        className="pagination"
                        linkClass="page-link"
                        itemClass="page-item"
                    />
                    <div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(UploadHistorySubComponent);
